import { useCallback, useEffect, useRef } from 'react'

import { useNotificacoes } from '@/contexts/contexto-notificacoes'
import { useFecharAoClicarFora } from '@/hooks'

export function useBloc() {
  const {
    existemNaoVisualizadas,
    quantidadeNaoVisualizadas,
    popupAberto,
    setPopupAberto,
  } = useNotificacoes()

  const referenciaDoContainer = useRef<HTMLLIElement>(null)
  const fixadoRef = useRef<boolean>(false)

  const fecharPopup = useCallback(() => {
    fixadoRef.current = false
    setPopupAberto(false)
  }, [setPopupAberto])

  const alternarPopup = useCallback(() => {
    if (fixadoRef.current) {
      fecharPopup()
      return
    }

    fixadoRef.current = true
    setPopupAberto(true)
  }, [fecharPopup, setPopupAberto])

  const aoPassarMouse = useCallback(() => {
    setPopupAberto(true)
  }, [setPopupAberto])

  const aoTirarMouse = useCallback(() => {
    if (fixadoRef.current) return

    setPopupAberto(false)
  }, [setPopupAberto])

  useFecharAoClicarFora(referenciaDoContainer, popupAberto, fecharPopup)

  useEffect(() => {
    if (!popupAberto) return

    function aoPressionarTecla(evento: KeyboardEvent): void {
      if (evento.key !== 'Escape') return

      evento.stopPropagation()
      fecharPopup()
    }

    document.addEventListener('keydown', aoPressionarTecla)

    return () => {
      document.removeEventListener('keydown', aoPressionarTecla)
    }
  }, [popupAberto, fecharPopup])

  const rotuloDoBotao = existemNaoVisualizadas
    ? `Notificações, ${quantidadeNaoVisualizadas} não visualizadas`
    : 'Notificações'

  return {
    referenciaDoContainer,
    popupAberto,
    existemNaoVisualizadas,
    rotuloDoBotao,

    alternarPopup,
    fecharPopup,
    aoPassarMouse,
    aoTirarMouse,
  }
}
